import { Link } from "gatsby";
import styled from "styled-components";

import { Box, ListItem, Text } from "@vinomofo/components";

const PageLink = styled(Box)`
  text-decoration: none;
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.brand : theme.colors.white};
  color: ${({ theme, isActive }) =>
    isActive ? theme.colors.white : theme.colors.text.normal};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

  &:hover {
    border: 1px solid
      ${({ theme, isActive, isDisabled }) =>
        isDisabled
          ? theme.colors.white
          : isActive
          ? theme.colors.brand
          : theme.colors.divider};
  }
`;

const Seperator = () => {
  return (
    <Text variant="sm" lineHeight="none">
      &#8230;
    </Text>
  );
};

interface PageControlProps {
  control: number | string;
  isActive: boolean;
  separator: boolean;
  isDisabled?: boolean;
  icon?: JSX.Element;
}

export const PageControl = ({
  control,
  isActive,
  icon,
  separator,
  isDisabled = false,
  ...rest
}: PageControlProps): JSX.Element => {
  return (
    <ListItem as="li" lineHeight="none" mx="4px">
      {separator ? (
        <Seperator />
      ) : (
        <PageLink
          as={isDisabled ? "span" : Link}
          display="flex"
          alignItems="center"
          justifyContent="center"
          padding="4px 0"
          borderRadius="50%"
          width="30px"
          height="30px"
          isActive={isActive}
          isDisabled={isDisabled}
          {...rest}
        >
          {icon ? (
            icon
          ) : (
            <Text
              as="span"
              fontFamily="heading"
              variant="sm"
              lineHeight="none"
              color="inherit"
              fontWeight={500}
            >
              {control}
            </Text>
          )}
        </PageLink>
      )}
    </ListItem>
  );
};
